import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@evaneos/b2b-ui';
import { useIntl } from 'react-intl';

type DuplicateModalProps = {
    open: boolean;
    setOpen: (open: boolean) => void;
    title: string;
    description: string;
    confirmButtonTitle: string;
    confirmButtonColor: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
    handleConfirmation: () => void;
};

export const DuplicateModal = ({
    open,
    setOpen,
    title,
    description,
    confirmButtonTitle,
    confirmButtonColor,
    handleConfirmation,
}: DuplicateModalProps) => {
    const { formatMessage } = useIntl();

    const handleConfirmationClick = () => {
        setOpen(false);
        handleConfirmation();
    };

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title" variant="h2">
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description" variant="body1">
                    {description}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="text" color="secondary" onClick={() => setOpen(false)}>
                    {formatMessage({
                        id: 'form.cancel',
                    })}
                </Button>
                <Button
                    color={confirmButtonColor}
                    disableElevation={true}
                    autoFocus
                    onClick={handleConfirmationClick}
                >
                    {confirmButtonTitle}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
